module.exports = __webpack_public_path__ + "img/close-sidebar-icon.14a50943.svg";